enum AccountFeatures {
  WhiteLabeling = 'whiteLabeling',
  AIModule = 'aiModule',
  QuizAgent = 'quizAgent',
  BetaQuestions = 'betaQuestions',
  Events = 'events'
}

export default AccountFeatures;
